module.exports = __webpack_public_path__ + "static/wind-turbine-ee675136a2b5dd6691f6d316a6292b84.mp4";